import moment from 'moment';

export const setWithExpiry = (key, value, expires) => {
  const item = {
    value,
    expiresAt: moment(expires).valueOf(),
  };

  localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key) => {
  const raw = localStorage.getItem(key);
  if (!raw) return null;

  try {
    const item = JSON.parse(raw);

    if (!item.expiresAt || moment().valueOf() > item.expiresAt) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
};
